import { useEffect, useState } from "react";
import Heading from "../../../components/Heading";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TableList from "./components/TableList.jsx";
import { ActionButton } from "../../../components/Forms/ActionButton";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { eventCategoryList } from "../../../api/events.js";
import { useHeader } from "../../../context/HeaderContext.js";

const EventCategoryList = () => {

  const navigate = useNavigate();

  const { setHeaderTitle } = useHeader();

  useEffect(() => {
    setHeaderTitle('View Event Category List');
    return () => {
      setHeaderTitle('');
    };
  }, [setHeaderTitle]);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeStatus, setActiveStatus] = useState("");

  // Fetch category data on component mount
  useEffect(() => {
    eventCategoryList((fetchedData) => {
      setData(fetchedData);
      setFilteredData(fetchedData); // Initialize filtered data
    }, toast);
  }, []);

  // Handle filtering logic
  const handleFilter = () => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const newFilteredData = data.filter((item) => {
      const matchesSearch = item.name.toLowerCase().includes(lowerSearchTerm);
      const matchesStatus = activeStatus === "" || item.active.toString() === activeStatus;
      return matchesSearch && matchesStatus;
    });
    setFilteredData(newFilteredData);
  };

  // Handle reset logic
  const handleReset = () => {
    setSearchTerm("");
    setActiveStatus("");
    setFilteredData(data); // Reset to original data
  };

  return (
    <main className="flex flex-col font-semibold text-gray-900 rounded-none mr-0 text-base">

      {/* <Heading text={"View Event Category List"} /> */}
      {/* Filters */}
      <div className="flex flex-col px-5 py-4 w-full text-sm font-semibold bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:pl-5 max-md:max-w-full">
        <div className="flex gap-1.5 items-center justify-between text-gray-900 max-md:max-w-full">
          <div className="flex gap-1.5 items-center text-gray-900 max-md:max-w-full">
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
              alt=""
              className="object-contain shrink-0 w-4 aspect-square"
            />
            <h1 className="self-start text-base font-bold">Filters</h1>
          </div>
          <div className="flex gap-2.5 items-center w-fit whitespace-nowrap">
            <ActionButton
              variant="reset"
              text="+ Add New"
              handleSubmit={() => navigate('/events/event-categories/create-categories')}
            />
          </div>
        </div>
        <div className="mt-3 flex gap-8 w-full max-md:max-w-full">
          <form
            className="flex w-full flex-auto gap-2.5 self-start p-2 mt-1 tracking-widest whitespace-nowrap rounded-md border border-solid bg-zinc-300 bg-opacity-0 border-navBtn text-zinc-400"
            onSubmit={(e) => {
              e.preventDefault();
              handleFilter();
            }}
          >
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/a945212e3480badae8ec120c2470ee1a05ad62400839168e9007e1ac6f6d6f87?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
              alt=""
              className="object-contain shrink-0 self-start w-5 aspect-square"
            />
            <input
              type="search"
              placeholder="Search..."
              aria-label="Search"
              className="flex-auto max-md:max-w-full bg-transparent border-none outline-none text-base"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </form>
        </div>
        <div>
          {/* Status */}
          <div className="flex-col w-fit mt-3">
            <label htmlFor="activeStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
              Status
            </label>
            <Select
              options={[
                { value: 'true', label: 'Active' },
                { value: 'false', label: 'Inactive' },
              ]}
              className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
              onChange={(selectedOption) => setActiveStatus(selectedOption.value)}
              value={activeStatus ? { value: activeStatus, label: activeStatus === 'true' ? 'Active' : 'Inactive' } : null}
              placeholder="Select Status"
              isMulti={false}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: 'transparent',
                  border: '1px solid rgba(224, 230, 237, 1)',
                  borderRadius: '0.375rem',
                  boxShadow: 'none',
                  padding: '0.25rem',
                  ":hover": {
                    borderColor: '#16ad3c',
                  },
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                option: (base, { isSelected }) => ({
                  ...base,
                  backgroundColor: isSelected ? '#16ad3c' : 'white', // Custom background for selected option
                  color: isSelected ? 'white' : 'black', // Custom text color for selected option
                  ":active": {
                    backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)', // Active state
                  },
                  ":hover": {
                    backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)', // Hover state
                  },
                }),
                singleValue: (base) => ({
                  ...base,
                  color: 'black',
                }),
                placeholder: (base) => ({
                  ...base,
                  color: 'gray',
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: 'gray',
                }),
                indicatorSeparator: (base) => ({
                  ...base,
                  display: 'none',
                }),
                clearIndicator: (base) => ({
                  ...base,
                  color: 'gray',
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: '0.25rem',
                }),
                input: (base) => ({
                  ...base,
                  color: 'black',
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: '200px',
                }),
              }}
            />
          </div>
          <div className="flex justify-end gap-2.5 mt-10">
            <ActionButton variant="reset" text="Reset" handleSubmit={handleReset} />
            <ActionButton variant="submit" text="Search" handleSubmit={handleFilter} />
          </div>
        </div>
      </div>
      <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
        <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
          <h1 className="self-start text-lg font-semibold">Event Category List</h1>
          <TableList data={filteredData} setData={setData} toast={toast} />
        </div>
      </section>
      <ToastContainer position="top-right" />
    </main>
  );
};

export default EventCategoryList;